import * as React from 'react';
import { EntityConfig, entityTaxonomyFormFields } from '@shapeable/core';
import { RegionType as MyType } from '@shapeable/kelp-forest-alliance-types';

export const RegionType: EntityConfig<MyType> = {
  name: 'RegionType',
  slug: 'region-type',
  label: 'Region Type',
  type: 'taxonomy',
  form: {
    fields: {
      ...entityTaxonomyFormFields,
      description: { type: 'description' },
    }
  },
  select: {
    maxWidth: '400px',
  },
  autoRoutes: ['list', 'create', 'update'],
};